import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import ReviewCarouselImages from 'components/pdp/shared-components/review-carousel-images/ReviewCarouselImages'
import Typo from 'constants/typography'
import clsx from 'clsx'
import styles from './product-style-gallery-images.scss'

const ProductStyleGalleryImages = ({ viewIndex, productReviewImages }) => {
  // effects
  useEffect(() => {
    const onClickThumbnail = () => {
      const galleryImg = document.getElementById(
        `product-style-gallery-img-${viewIndex}`,
      )
      if (galleryImg) {
        galleryImg.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      }
    }
    onClickThumbnail()
  }, [viewIndex])

  return (
    <div className="product-style-gallery-images-container">
      <style jsx>{styles}</style>
      {productReviewImages.map((reviewImage, idx) => {
        const images = reviewImage?.images?.map((img) => ({
          image_url: img?.image_url,
          id_product_review_image: img?.position,
        }))
        const isShowDivider = productReviewImages.length - idx !== 1

        return (
          <div
            key={reviewImage?.id_order}
            id={`product-style-gallery-img-${idx}`}
            className="product-style-gallery-images-container__img"
            data-cy="product-style-gallery-images-container__img"
          >
            <ReviewCarouselImages selectedImageIndex={0} images={images} />
            <div className="product-style-gallery-images-container__info">
              <div className={clsx(Typo.subtitle1)}>{reviewImage?.name}</div>
              <div
                className={clsx(
                  Typo.body2,
                  'product-style-gallery-images-container__info__date',
                )}
              >
                {reviewImage?.create_ts}
              </div>
            </div>
            <div className={clsx(Typo.body2)}>{reviewImage?.caption}</div>
            {isShowDivider && (
              <div
                data-cy="product-style-gallery-images-container__divider"
                className="product-style-gallery-images-container__divider"
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

ProductStyleGalleryImages.defaultProps = {
  // component props
  viewIndex: 0,
  productReviewImages: [],
}

ProductStyleGalleryImages.propTypes = {
  // component props
  viewIndex: PropTypes.number,
  productReviewImages: PropTypes.arrayOf(
    PropTypes.shape({
      id_order: PropTypes.number,
      id_product_attribute: PropTypes.number,
      caption: PropTypes.string,
      create_ts: PropTypes.string,
      name: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          position: PropTypes.number,
          image_url: PropTypes.string,
        }),
      ),
    }),
  ),

  // redux props
  internationalization: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    internationalization: state.internationalization,
  })),
  withI18next(),
)(ProductStyleGalleryImages)
